import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore.js';

// Import the ant design style
import 'antd/dist/antd.min.css';

// Import the boostrap style
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import {
    BrowserRouter,
} from "react-router-dom";

import App from './App.js';


let store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);


// ReactDOM.render(
//     <Provider store={store}>
//             <Root />
//     </Provider>,
//     document.getElementById('root')
// );
